// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DHN4","type":"styles_type__ZJ9ED","choices":"styles_choices__1nZOt"};